import CustomInput from 'components/custom-input/custom-input.component';
import styled from 'styled-components';

export const Container = styled(CustomInput)`
  margin: 1em 0em;
`;
